/* eslint-disable no-unused-vars */
const validationSummaryValid = 'validation-summary-valid';
const validationSummaryErrors = 'validation-summary-errors';
const alertWarning = 'alert-warning';
const alertDanger = 'alert-danger';

function swapClasses(el, oldClass, newClass) {
    el.removeClass(oldClass);
    el.addClass(newClass);
}

function errorSummaryOrDefault(displayEl) {
    return displayEl || $('#error-summary');
}

function createErrors(errors) {
    const entries = [];
    Object.keys(errors).forEach((error) => {
        const errorMessages = errors[error];
        errorMessages.forEach((message) => {
            entries.push({ propertyName: error, errorMessage: message });
        });
    });

    return entries;
}

function createErrorListItem(data) {
    const propertyName = data.propertyName || data.identifier || data.ctrl;
    const errorMessage = data.errorMessage || data.msg || data;
    const li = document.createElement('li');
    li.className = 'text-danger';
    const a = document.createElement('a');
    // eslint-disable-next-line no-script-url
    a.href = 'javascript: void 0;';
    a.onclick = () => { window.setFocus(propertyName); };
    a.innerHTML = errorMessage;
    li.append(a);
    return li;
}

function createErrorList(errorSummaryEl) {
    const alertBody = errorSummaryEl.find('.alert__body');
    return alertBody.find('ul');
}

function emptyErrorSummary(display) {
    const errorSummaryEl = errorSummaryOrDefault(display);
    const alertUl = createErrorList(errorSummaryEl);
    if (alertUl.length) {
        alertUl.empty();
    }

    swapClasses(errorSummaryEl, validationSummaryErrors, validationSummaryValid);
}

function appendErrorToSummary(data, displayEl) {
    const errorSummaryEl = errorSummaryOrDefault(displayEl);
    const alertUl = createErrorList(errorSummaryEl);
    const li = createErrorListItem(data);
    alertUl.append(li);
}

function setValidationSummaryErrorClass(errorSummaryEl) {
    errorSummaryEl.removeClass('d-none');
    swapClasses(errorSummaryEl, validationSummaryValid, validationSummaryErrors);
}

function displaySummary(data, display, type) {
    emptyErrorSummary(display);
    const errorSummaryEl = errorSummaryOrDefault(display);
    switch (type) {
    case 'warning':
        swapClasses(errorSummaryEl, alertDanger, alertWarning);
        break;
    case 'danger':
    default:
        swapClasses(errorSummaryEl, alertWarning, alertDanger);
        break;
    }

    if (data.length > 0) {
        data.map((err) => appendErrorToSummary(err, display));
    }

    setValidationSummaryErrorClass(errorSummaryEl);
}

function displayErrorSummary(data, display) {
    displaySummary(data, display, 'danger');
}

function displayWarningSummary(data, display) {
    displaySummary(data, display, 'warning');
}

function displayErrorMessage(msg) {
    const errorSummaryEl = $('#error-summary');
    const errorSummaryUl = $('#error-ul');
    const li = document.createElement('li');
    li.className = 'text-danger';
    li.innerHTML = msg;
    errorSummaryUl.append(li);
    errorSummaryEl.removeClass('d-none');
}

function clearErrorMessage() {
    $('.field-validation-error').html('').removeClass('.field-validation-error');
    $('#divStatus').html('');
}

function displayErrorMessages(errorList) {
    clearErrorMessage();
    $.each(errorList, (idx, value) => {
        // propertyName comes from Ardalis.Result ValidationError.
        // identifier comes from ModelState.
        const fieldName = value.propertyName || value.identifier;
        const container = $(`span[data-valmsg-for="${fieldName}"]`);
        container.addClass('field-validation-error');
        container.html(value.errorMessage);
    });
}

function clearErrors(display) {
    clearErrorMessage();
    emptyErrorSummary(display);
}

function displayErrors(errorList, display) {
    displayErrorSummary(errorList, display);
    displayErrorMessages(errorList);
}

function displayAndFocusErrors(errorList, display) {
    $('html, body').animate({ scrollTop: 0 }, 'fast');
    // window.scrollTo(0, 0);
    displayErrors(errorList, display);
}
